import React, { Component } from "react";
import styled from "styled-components";
import { compose } from "react-apollo";
import withQuery from "containers/withQuery";
import gql from "graphql-tag";
import { withRouter } from "react-router";
import { Container, Row, Col, media } from "styled-bootstrap-grid";
import PropTypes from "prop-types";
import theme from "ui/styles/theme";

// Styles
const Form = styled.div`
padding-bottom: 20px;

&&#form-container-popup {
    * {
      font-family: "Work Sans";
      color: black;
      font-size: 14px;
    }
    
    ._marketing-by {
    display: none;
    }

    ._field1, ._x29757849 {
      display: none;
    }


    form {
      width: 100%;
      height: 100%;
      padding: 0;
      background: none !important;
      border: none !important;
    }

    p {
      font-size: 16px !important;
    }

    ._form-content{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }

    ._x06147226 {
      width: 40%;
      flex-grow: 2;
    }

    ._x74459413 {
      width: 40%;
      flex-grow: 2;
      margin-left: 5%;
    }

    ._field32 {
      width: 40%
      flex-grow: 2;
    }

    
    ._field32 option {
      width: 80%;
      color: black;
    } 

    ._field57 {
      width: 40%;
      flex-grow: 2;
      margin-left: 5%;
    }

    ._field57 option {
      color: black;
      width: 80%;
    }

    ._form-title {
    ${media.md`
      font-size: 35px !important;
      `}
    font-size: 22px !important;
    font-weight: 350 !important;
    line-height: 1 !important;
      @media screen and (min-width: 1500px){
        font-weight: 500 !important;
        font-size: 1vw !important;
        white-space: nowrap;
      }
      @media screen and (min-width: 1700px){
        font-weight: 500 !important;
        font-size: 0.8vw !important;
        white-space: nowrap;
      }
    }

    ._form-label {
      font-weight: 500;
    }

    ._form_element {
      margin-bottom: 0.5em;
    }
    
    ._form-branding {
        display:none;
    }

    ._field-wrapper {
      select,
      input {
        background: white;
        color: black !important;
          appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: #ffffff;
  color: #333;
  font-size: 16px;
  padding: 0px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 0.3s, box-shadow 0.3s;

        &::placeholder {
          color: white;
        }
      }
    }

    textarea:focus {
      height: 8em !important;
    }


    ._submit {
      background: #00994c !important;
      text-transform: uppercase;
      border-radius: 2em !important;
      padding: 0.5em 1.5em !important;
      transition: all .2s ease-in-out !important;
    }

    ._submit:hover {
      background: #00994cad !important;
    }

  }

  ${media.sm`
  width: 100%;
`}
`;

const Wrapper = styled.section`
  z-index: 99;
  position: fixed;
  bottom: 0;
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  ${media.md`
      justify-content: space-between;
      max-width: 850px;
      height: auto;
    `}
`;

const Titlecontainer = styled.div`
  color: black;
  text-align: center;
  padding: 0px;
  display: flex;
  justify-content: flex-end;
  padding: 5px;
  position: relative;
  overflow: hidden; /* Ensures the background doesn't go outside the container */

  ${media.md`
    padding: 20px;  
    `}
`;
const Title = styled.div`
  flex-grow: 2;
  font-size: 35px !important;
  font-weight: 350 !important;
  line-height: 1 !important;
  margin-bottom: 0 !important;
  padding: 10px;
  color: white;
  ${media.md`
    color: black;
    `}
  z-index: 1;
  p {
    margin-bottom: 0;
  }
`;

const Text = styled.div`
  color: black;
`;
const Modal = styled.div`
  width: 100%;
  background-color: white;
  margin: auto;
  max-width: 810px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: auto;
  margin-left: auto;
  font-size: 14px;
  ${media.md`
    margin-top: auto;
    margin-bottom: 0;
    margin-right: 0;
    margin-left: 0;
    `}
  ${media.xs`
width: 91%;
`}
`;
const Image = styled.div`
  width: 100%;
  background: url(${(props) => props.image}) center / cover;
  height: 100%;

  /*Mobile specific*/
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;

  ${media.md`
    position: static;
  top: unset;
  left: unset;
  width: 100%;
  height: 100%;
  min-height: 200px;
    `}
`;
const Tab = styled(Row)`
  && {
    padding: 0;
    margin: 0;
  }

  .picture {
    padding: 0;
  }
`;
const Popupcontainer = styled(Container)`
  && {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
`;
const Close = styled.button`
  overflow: hidden;
  position: relative;
  border: none;
  padding: 0;
  width: 2em;
  height: 2em;
  border-radius: 50%;
  background: transparent;
  color: white;
  font: inherit;
  text-indent: 100%;
  cursor: pointer;

  ${media.md`
    color: #1da1f2;
    `}

  &:focus {
    outline: solid 0 transparent;
    box-shadow: 0 0 0 2px #8ed0f9;
  }

  &:hover {
    background: rgba(29, 161, 142, 0.1);
  }

  &:before,
  &:after {
    position: absolute;
    top: 15%;
    left: calc(50% - 0.0625em);
    width: 0.125em;
    height: 70%;
    border-radius: 0.125em;
    transform: rotate(45deg);
    background: currentcolor;
    content: "";
  }

  &:after {
    transform: rotate(-45deg);
  }
`;

class Popup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: false,
      appended: false,
      initialized: false,
      sameUrl: false,
      isMobile: false,
      urlNow: "",
      popped: false,
      isPageLoaded: false,
    };
  }
  static propTypes = {
    optionsPopups: PropTypes.object,
    optionsPopupsLoading: PropTypes.bool,
  };

  static defaultProps = {
    optionsPopups: undefined,
    optionsPopupsLoading: true,
  };

  componentDidMount() {
    const { optionsPopups } = this.props;
    window.addEventListener("resize", this.detectMobile);
    // Attach the load event listener
    window.addEventListener("load", this.handlePageLoad);
    this.detectMobile();
    console.log("From popup");
  }

  handlePageLoad = () => {
    this.setState({ isPageLoaded: true });
    console.log("Page fully loaded");
  };

  //Required only in the local server
  componentDidUpdate(prevProps, prevState) {
    //console.log('prev state = ' + prevState.urlNow)
    let curUrl = window.location.href;
    let localVar = sessionStorage.getItem("popped");
    if (this.props.optionsPopups) {
      if (prevState.urlNow !== curUrl) {
        this.changeUrl();
        this.checkUrl();
      }
    }
  }

  //Create form tooltip
  createTooltip = (message) => {
    const tooltip = document.createElement("div");
    tooltip.innerText = message;
    tooltip.style.position = "relative";
    tooltip.style.background = "#333";
    tooltip.style.color = "#fff";
    tooltip.style.padding = "5px 10px";
    tooltip.style.borderRadius = "4px";
    tooltip.style.fontSize = "12px";
    tooltip.style.display = "none";
    tooltip.style.zIndex = "1000";
    return tooltip;
  };

  changeUrl = () => {
    this.setState({ urlNow: window.location.href });
  };

  appendForm = () => {
    const { optionsPopups } = this.props;
    if (this.state.appended === false) {
      console.log("appending script");
      const script = document.createElement("script");
      const pageUrl = window.location.href;
      script.src = `https://dol-sensors67660.activehosted.com/f/embed.php?id=${optionsPopups.popupNewsId}`;
      script.async = true;
      script.setAttribute("id", "activecampaign-script-popup");
      document.body.appendChild(script);
      let formElement = document.getElementById("form-container-popup");
      this.setState({ appended: true });
      //Check if the form exist and add an eventListener
      script.onload = () => {
        if (formElement) {
          const fullNameInput = formElement.querySelector(
            'input[name="fullname"]'
          );
          const submitButton = formElement.querySelector(
            `#${"_form_" + optionsPopups.popupNewsId + "_submit"}`
          );
          //If form has a fullname input field check if there is a space (So we know it is a first and a last name)
          if (fullNameInput) {
            const tooltip = this.createTooltip(
              "Please enter your first and last name"
            );
            formElement.appendChild(tooltip); // Append tooltip to the body
            const containerRect = fullNameInput.getBoundingClientRect();
            // Position tooltip and display it on focus
            fullNameInput.addEventListener("focus", (e) => {
              if (this.state.validated === false) {
                tooltip.style.display = "block";
                submitButton.setAttribute("disabled", "true");
              }
            });

            fullNameInput.addEventListener("input", (e) => {
              const fullName = e.target.value.trim();
              if (!/^\S+\s+\S+/.test(fullName)) {
                e.target.style.borderColor = "red";
                tooltip.style.display = "block";
                this.setState({ validated: false });
                if (!submitButton.hasAttribute("disabled")) {
                  submitButton.setAttribute("disabled", "true");
                }
              } else {
                e.target.style.borderColor = "";
                tooltip.style.display = "none";
                this.setState({ validated: true });
                if (submitButton.hasAttribute("disabled")) {
                  submitButton.removeAttribute("disabled");
                }
              }
            });
          }
        }
      };
    }
  };

  initializePopup = () => {
    if (this.state.initialized === false) {
      setTimeout(() => {
        this.setState({ opened: true, initialized: true });
        this.appendForm();
      }, this.props.optionsPopups.timeToPop);
    }
  };

  popupOpen = () => {
    if (this.state.opened === false) {
      //this.setState({ opened: true }, console.log("opened"), this.appendForm);
    } else {
      this.setState({ opened: false }, console.log("closed"));
    }
  };

  detectMobile = () => {
    const width = window.innerWidth;
    const isMobile = width <= theme.grid.breakpoints.md;

    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  };

  setLocalStorage = () => {
    sessionStorage.setItem("popped", "true");
  };

  checkUrl = () => {
    let urls = this.props.optionsPopups.pageURLs;
    let currentUrl = window.location.href;
    let currentLast = currentUrl.charAt(currentUrl.length - 1);
    if (currentLast !== "/") {
      currentUrl = window.location.href + "/";
    }

    let urlArray = [];
    if (sessionStorage.getItem("popped") === null) {
      sessionStorage.setItem("popped", "");
    }
    let localValue = sessionStorage.getItem("popped");
    Object.entries(urls).forEach((url) => {
      urlArray.push(url[1].popups__pageURL);
    });
    if (localValue !== "true") {
      if (urlArray.includes(currentUrl) || this.props.optionsPopups.allPages) {
        this.setState({ sameUrl: true });
        this.initializePopup(this.setLocalStorage());
      } else {
        this.setState({ sameUrl: false });
      }
    }
  };

  render() {
    const { optionsPopupsLoading, optionsPopups } = this.props;

    if (optionsPopupsLoading) return null;

    const {
      popupNewsId,
      popupHeader,
      pageURLs,
      popupText,
      popupImage,
      allPages,
      timeToPop,
    } = optionsPopups;

    return (
      <Wrapper
        style={{ display: this.state.opened !== false ? "flex" : "none" }}
      >
        {this.state.opened && (
          <Modal>
            <Titlecontainer>
              {this.state.isMobile && (
                <Image image={popupImage && popupImage.sourceUrl}></Image>
              )}
              <Title dangerouslySetInnerHTML={{ __html: popupHeader }}></Title>
              <Close onClick={this.popupOpen}></Close>
            </Titlecontainer>
            <Popupcontainer fluid>
              <Tab>
                <Col
                  md={6}
                  className={"picture"}
                  style={{
                    display: this.state.isMobile === true ? "none" : "block",
                  }}
                >
                  <Image image={popupImage && popupImage.sourceUrl}></Image>
                </Col>
                <Col
                  md={6}
                  sm={12}
                  style={{ minHeight: "100px", alignContent: "center" }}
                >
                  {popupNewsId && (
                    <Form
                      className={`_form_${popupNewsId} mx-auto`}
                      id="form-container-popup"
                    />
                  )}
                </Col>
              </Tab>
            </Popupcontainer>
          </Modal>
        )}
      </Wrapper>
    );
  }
}

export default compose(
  withRouter,
  withQuery(
    () => gql`
      {
        optionsPopups {
          popupHeader
          popupNewsId
          popupText
          allPages
          timeToPop
          popupImage {
            sourceUrl
          }
          pageURLs {
            popups__pageURL
          }
        }
      }
    `,
    "optionsPopups"
  )
)(Popup);



// WEBPACK FOOTER //
// ./src/ui/components/Popup.js